export enum ToggleGroupDataAttributes {
  /**
   * Present when the toggle group is disabled.
   */
  disabled = 'data-disabled',
  /**
   * Indicates the orientation of the toggle group.
   * @type {'horizontal' | 'vertical'}
   */
  orientation = 'data-orientation',
  /**
   * Present when the toggle group allows multiple buttons to be in the pressed state at the same time.
   */
  multiple = 'data-multiple',
}
